import SupportCategories from 'VueComponents/SupportCategories/SupportCategories.vue';
import SupportCategoriesNav from 'VueComponents/SupportCategories/SupportCategoriesNav.vue';
import { createApp } from "vue";

let module:any = {};

/**
 * Instantiate Vue Application
 */
module.supportCategoriesVueApp = function () {
	// @ts-ignore
	const sc = createApp(SupportCategories);
	sc.mount("#supportCategories");
};

module.supportCategoriesNavVueApp = function () {
	// @ts-ignore
	const sc = createApp(SupportCategoriesNav);
	sc.mount("#supportCategoriesNav");
};


module.init = function () {
	module.supportCategoriesVueApp();
	module.supportCategoriesNavVueApp();
};

document.addEventListener("DOMContentLoaded", () => {
	module.init();
});
